import { createContext } from 'react';

import { ConfigProviderProps } from './types';

export const AppContext = createContext<ConfigProviderProps>({} as ConfigProviderProps);
